import { DESTINATION_TYPES } from '../constants/destinationTypes';
import { EntityStatus } from '../../../core/interfaces/entity-status';
import { GenericKeyValueType } from '../../../core/interfaces/generics';
import { Policy } from '../../scheduler/ExecutionPolicyDialog/models';
import { Policy as ExecutionPolicy } from '../../scheduler/models';

export interface RawDestination extends GenericKeyValueType<string, any> {
  id: number;
  name: string;
  type: string;
  status: string;
  activity_status: string;
  config: DestinationConfig;
  display_config: DestinationDisplayConfig;
  dest_type: string;
  dest_type_display: string;
  dest_type_logo_url: string;
  dest_type_dark_mode_logo_url: string;
  dest_type_description: string;
  search_keywords?: string[];
}

export interface DestinationConfig extends GenericKeyValueType<string, any> {
  is_table_type_transient?: boolean;
  region_id?: string;
  schema_name?: string;
  warehouse?: string;
  sanitize_name?: boolean;
  loaded_at?: boolean;
  version?: number;
  is_private_link?: boolean;
  db_name?: string;
  connection_version?: number;
  db_user?: string;
  account_name?: string;
  db_password?: string;
}

export interface DestinationDisplayConfig extends GenericKeyValueType<string, any> {
  "Account Name"?: string;
  Region?: string;
  Warehouse?: string;
  User?: string;
  Database?: string;
  Schema?: string;
  "Populate Loaded Timestamp"?: string;
  "Transient Tables"?: string;
}

export interface DestinationCompactData {
  destinationId: number;
  destTypeLogoUrl: string;
  destTypeDarkModeLogoUrl: string;
  destType: string;
  destName: string;
  hasAppendOnlyRecommendations?: boolean;
}

export interface DestinationRecommendationsData {
  hadRecommendations: boolean;
  hasPendingRecommendations: boolean;
  hadAppliedRecommendations: boolean;
}

export class Destination {
  seqId: number;
  id: number;
  name: string;
  destType: string;
  destTypeDisplay: string;
  createdByDisplayName: string;
  createdBy: number;
  displayDetails: Map<string, string>;
  destTypeLogoUrl: string;
  destTypeDarkModeLogoUrl: string;
  executionPolicy: Policy | ExecutionPolicy;
  hasSyncPolicy = false;
  displayDetailsArray: string[][];
  config: any = {};
  error: string;
  status: EntityStatus;
  oauthUserId: number;
  editConfigSupported: boolean;
  dedupEnabled?: boolean;
  validForWorkbenchView: boolean;
  validForTableLevelSyncStatusView: boolean;
  validForPendingEventsView: boolean;
  tablesSupported?: boolean;
  schemas?: any[];
  triggerBasedLoad?: boolean;
  triggerJobStatus?: string;

  constructor() {}

  canReauthoriseAccount() {
    return this.config && this.config.oauth_token_id;
  }

  editReAuthRequired(userId: number) {
    return this.config && this.config.oauth_token_id && this.oauthUserId !== userId;
  }

  canConnectBITools(userId: number) {
    return this.createdBy === userId;
  }

  isPartitionBased() {
    return DESTINATION_TYPES[this.destType].isPartitionBased;
  }
}

export enum DestinationConnectionActionableErrorStatus {
  DATA_REQUIRED = 'DATA_REQUIRED',
  CONFIRMATION_REQUIRED = 'CONFIRMATION_REQUIRED'
}

export enum DestinationVersions {
  STANDARD = 'STANDARD',
  EDGE = 'EDGE'
}
